import React, { useState } from "react";
import axios from "axios";
import "../styles/ReservationForm.css";
import apiUrl from "../config"; // import our dynamic API URL

const ReservationForm = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        date: "",
        guests: 1,
        specialRequests: "",
    });
    const [error, setError] = useState("");

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        const guestCount = parseInt(formData.guests);

        if (!formData.name || !formData.email || !formData.phone || !formData.date || !guestCount) {
            setError("Please fill in all required fields.");
            return;
        }

        if (guestCount === 1) {
            setError("You cannot reserve only for 1 person.");
            return;
        }

        const reservationDate = new Date(formData.date + "T00:00");
        const dayOfWeek = reservationDate.getDay();

        if (dayOfWeek === 1) {
            setError("Reservations cannot be made on Mondays.");
            return;
        }

        try {
            await axios.post(`${apiUrl}/api/reservations/complete-reservation`, {
                reservation: { ...formData, guests: guestCount }, // enforce numeric guest count
            });

            if ([4, 5, 6].includes(dayOfWeek)) {
                window.location.href = "/success";
            } else {
                window.location.href = "/reservation-success-unpaid";
            }
        } catch (error) {
            if (error.response?.data?.error) {
                setError(error.response.data.error);
            } else {
                console.error("Error processing reservation:", error);
                alert("Failed to process reservation. Please try again.");
            }
        }
    };



    return (
        <div>
            {/* Policy Section */}
            <div className="policy-container">
                <h2>Reservation Policies</h2>
                <div className="policy-details">
                    <p>
                        Reservations start at <strong>8:30 PM</strong>. We do not guarantee your seat or deposit if you
                        arrive after <strong>10 PM</strong>.
                    </p>
                    <p>
                        Deposit policy:
                        <ul>
                            <li>$50 for 1 guest</li>
                            <li>$100 for 2–10 guests</li>
                            <li>$200 for 11+ guests</li>
                        </ul>
                    </p>
                    <p>
                        <strong>Weekly Events:</strong>
                        <ul>
                            <li>Karaoke: Tuesday</li>
                            <li>Dancers and DJs: Friday and Saturday</li>
                            <li>DJs: Sunday</li>
                        </ul>
                    </p>
                    <p>
                        Please note that cancellations or changes to your reservation must be made at least 24 hours in
                        advance. Deposits are non-refundable in case of late cancellations or no-shows.
                    </p>
                </div>
            </div>

            {/* Reservation Form */}
            <form className="reservation-form" onSubmit={handleSubmit}>
                <h2>Make a Reservation</h2>
                {error && <p className="error-message">{error}</p>}

                {/* Row 1: Name & Email */}
                <div className="form-row">
                    <div className="form-group half">
                        <label htmlFor="name">Name</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            placeholder="Your Name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group half">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            placeholder="Your Email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>
                </div>

                {/* Row 2: Phone & Date */}
                <div className="form-row">
                    <div className="form-group half">
                        <label htmlFor="phone">Phone</label>
                        <input
                            type="tel"
                            id="phone"
                            name="phone"
                            placeholder="Your Phone"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group half">
                        <label htmlFor="date">Reservation Date</label>
                        <input
                            type="date"
                            id="date"
                            name="date"
                            value={formData.date}
                            onChange={handleChange}
                            required
                        />
                    </div>
                </div>

                {/* Row 3: Guests & Special Requests */}
                <div className="form-row">
                    <div className="form-group guests-group">
                        <label htmlFor="guests">Number of Guests</label>
                        <input
                            type="number"
                            id="guests"
                            name="guests"
                            min="1"
                            value={formData.guests}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group requests-group">
                        <label htmlFor="specialRequests">Special Requests</label>
                        <textarea
                            id="specialRequests"
                            name="specialRequests"
                            placeholder="Any special requests?"
                            value={formData.specialRequests}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                {/* Submit Button */}
                <div className="form-row submit-row">
                    <button type="submit">Submit Reservation</button>
                </div>
            </form>
        </div>
    );
};

export default ReservationForm;
